export default () => {
  throw new Error('This component throws an error during render');
};
